import frappe from './frappe';

// Retorna [categoriesWithID, categoryNames] para mantener compatibilidad con Products.js
export const fetchCategories = async () => {
  try {
    const { data } = await frappe.get(
      '/api/resource/Item%20Group?fields=["name","parent_item_group"]&limit=100'
    );
    const groups = data.data;

    const HIDDEN = new Set(['Sub Assemblies', 'All Item Groups']);

    const categoriesWithID = groups
      .filter(g => g.parent_item_group === 'All Item Groups' && !HIDDEN.has(g.name))
      .map(group => ({
        id: group.name,
        label: group.name,
        subcategories: groups
          .filter(g => g.parent_item_group === group.name)
          .map(sub => ({ id: sub.name, label: sub.name })),
      }));

    const categoryNames = categoriesWithID.map(c => c.label);

    return [categoriesWithID, categoryNames];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [[], []];
  }
};
